import { Link } from 'react-router-dom';

import imgEntree from '../assets/icons/Icon_entree.png';
import imgSortie from '../assets/icons/Icon_sortie.png';
import imgretour from '../assets/images/back-512x512.png';
import '../styles/precense.css';

function Precense() {
    const getVersionning = sessionStorage.getItem("versionning:");

    return (
        <div className="presence-container">
            {/* Bouton retour */}
            <div className="column retour">
                <Link to="/Accueil">
                    <img id="img-test" className="small" src={imgretour} alt="Retour" />
                </Link>
            </div>

            {/* Titre */}
            <h1 className="titre-presence">Présence</h1>
            {/* Icônes entrée / sortie */}
            <div className="actions-container">
                <div className="action-item">
                    <Link to="/Entree">
                        <img src={imgEntree} alt="Entrée" className="action-icon" />
                    </Link>
                    <span className="action-label">Entrée</span>
                </div>
                <div className="action-item">
                    <Link to="/Sortie">
                        <img src={imgSortie} alt="Sortie" className="action-icon" />
                    </Link>
                    <span className="action-label">Sortie</span>
                </div>
            </div>
            <footer>
                <span>{getVersionning}</span>
            </footer>
        </div>
    );
}

export default Precense;
